import ActiveLink from './ActiveLink';
import { withRouter } from 'react-router';

export default withRouter(ActiveLink);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ActiveLink/index.js